import React, { useState, useEffect } from 'react';
import { Col } from 'antd';

import { TextAreaCustom } from '../../../../components/TextAreaCustom';

import * as S from './styles';

export function Content({ data, change }) {
  const [observacao, setObservacao] = useState('');

  useEffect(() => {
    const newData = {
      ...data,
      observacao,
    };
    change({ data: newData });
  }, [observacao, change, data]);

  return (
    <S.Content>
      <Col
        justify="start"
        style={{
          width: '100%',
        }}
      >
        <TextAreaCustom
          title="Observações:"
          placeholder="Digite aqui"
          lengthText={5000}
          changeText={setObservacao}
        />
      </Col>
    </S.Content>
  );
}
